module.exports = __webpack_public_path__ + "h5/img/bg.c4cc7fb9.png";